
import React from "react"
import { useSelector } from "react-redux";
import { AssessmentTypeEnum } from "../../../../models/AssessmentTypeEnum";
import { ReflectionActionsEnum } from "../../../Shared/ReflectionActionsEnum";
import { ReflectionComponentsEnum } from "../../../Shared/ReflectionComponentsEnum";
import classes from './QuestionType.module.css';

const QuestionType = ({  setQuestion, question}) => {
    const { texts } = useSelector(state => state.translate);


    return (
        <>
            <div className={classes.Title}>{texts.chooseReflectionType}</div>
            <div className={`${classes.ReflectionTypes}`}>
                {Object.keys(AssessmentTypeEnum).slice(4,8).map((questionType, index) => {
                    const QuestionTypeComponent = ReflectionComponentsEnum[questionType];
                    return (
                        <div key={index} className={`${question?.type === AssessmentTypeEnum[questionType] && classes.CurrentTypeBorder}  ${classes.ReflectionBox}`}
                            onClick={() => { setQuestion({ ...question, type: AssessmentTypeEnum[questionType] })}}>
                            <QuestionTypeComponent action={ReflectionActionsEnum.CRUD} />
                        </div>)
                }
                )}
            </div>
        </>
    )
}

export default QuestionType;